import { OutlinedInput } from "@material-ui/core";

export default  {
    defaultProps: {
      margin: "dense",
      variant: "outlined",
    },
  }